import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(Settings.api.player, {
  get: {
    'media.subtitle.list': '/subtitle/:mediaCode',
    'media.subtitle.track': '/subtitle/:mediaCode/:subtitleCode/cues',
    'media.subtitle.transcribe.supported_langs':
      '/subtitle/transcribe/supported-lang'
  },
  put: {
    'media.subtitle.update': '/subtitle/:mediaCode/:subtitleCode',
    'media.subtitle.update_cues': '/subtitle/:mediaCode/:subtitleCode/cues'
  },
  post: {
    'media.subtitle.retry': '/subtitle/:mediaCode/:subtitleCode/retry',
    'media.subtitle.transcribe': '/subtitle/:mediaCode/transcribe',
    'media.subtitle.translate':
      '/subtitle/:mediaCode/:subtitleCode/translate/:languageCode',
    'media.subtitle.approve': '/subtitle/:mediaCode/:subtitleCode/approve',
    'media.subtitle.upload': {
      options: {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      },
      path: '/subtitle/:mediaCode/:languageCode'
    }
  },
  delete: {
    'media.subtitle.delete': '/subtitle/:mediaCode/:subtitleCode'
  }
});
